module.exports = __webpack_public_path__ + "img/water.831a2dcd.svg";